var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArborescence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100.000000pt",
    height: "100.000000pt",
    viewBox: "0 0 100.000000 100.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,100.000000) scale(0.100000,-0.100000)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75 991 c-74 -33 -96 -133 -41 -190 34 -36 82 -48 128 -32 32 11 33 10 107 -63 l74 -74 -18 -38 c-26 -54 -30 -106 -12 -158 l16 -45 -63 -51 -63 -50 -33 16 c-44 22 -96 12 -135 -26 -25 -26 -30 -38 -30 -80 0 -43 5 -54 33 -82 28 -28 39 -33 82 -33 43 0 54 5 82 33 29 29 33 38 33 89 l0 56 59 48 59 48 26 -18 c43 -30 99 -44 151 -37 l47 6 24 -45 c20 -37 22 -48 11 -62 -42 -60 -39 -120 8 -168 26 -25 38 -30 80 -30 43 0 54 5 82 33 28 28 33 39 33 82 0 66 -40 110 -109 117 -41 5 -48 10 -72 50 l-25 44 24 19 c13 11 32 36 42 55 11 25 21 35 32 31 8 -3 23 -6 33 -6 12 0 20 -10 24 -33 3 -19 20 -47 37 -63 25 -24 39 -29 79 -29 43 0 54 5 82 33 28 28 33 39 33 82 0 43 -5 54 -33 82 -28 29 -39 33 -83 33 -45 0 -54 -4 -83 -35 -29 -32 -36 -35 -64 -28 -23 6 -32 14 -32 30 0 61 -43 137 -93 165 -17 9 -18 14 -7 50 11 37 16 41 53 46 27 4 50 16 71 36 26 27 31 39 31 81 0 43 -5 54 -33 82 -28 28 -39 33 -82 33 -43 0 -54 -5 -82 -33 -28 -28 -33 -39 -33 -82 0 -40 5 -54 27 -77 28 -29 28 -30 12 -69 -15 -38 -16 -39 -67 -39 -30 0 -68 -9 -90 -19 l-39 -19 -74 74 c-73 74 -74 75 -63 107 25 72 -23 150 -97 158 -22 2 -48 0 -59 -5z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArborescence);
export default __webpack_public_path__ + "static/media/arborescence.6347e3e0.svg";
export { ForwardRef as ReactComponent };